import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

import Alpine from "alpinejs";
const isMobile = window.matchMedia("(max-width: 768px)").matches;
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.config({
  ignoreMobileResize: false,
  autoRefreshEvents: "visibilitychange",
});

document.addEventListener("alpine:init", () => {
  Alpine.data("menuState", () => ({
    menuVisible: false,
    filtersActive: false,
    open: false,
    hoverTimeout: null,
    activeCategory: null,
    isHome: false,
    isMobile: window.matchMedia("(max-width: 768px)").matches,
    headerBg: null,

    init() {
      this.isMobile = window.matchMedia("(max-width: 768px)").matches;
      this.headerBg = document.querySelector(".header-bg");
      if (!this.isMobile) {
        const isHome = document.querySelector("main.home-template") !== null;
        const blockIntro = document.querySelector(".block-intro");

        if (isHome && blockIntro) {
          ScrollTrigger.create({
            trigger: blockIntro,
            start: "top-=15px top",
            end: "bottom top-=15px",
            onEnter: () => (this.menuVisible = true),
            onEnterBack: () => (this.menuVisible = true),
            onLeave: () => (this.menuVisible = false),
            onLeaveBack: () => (this.menuVisible = false),
          });

          this.menuVisible = blockIntro.getBoundingClientRect().bottom > 0;
        }
      } else {
        this.menuVisible = false;
      }

      const match = window.location.pathname.match(/category[;:]([^/]+)/);
      this.activeCategory = match ? decodeURIComponent(match[1]) : null;

      window.addEventListener("popstate", () => {
        const newMatch = window.location.pathname.match(/category[;:]([^/]+)/);
        this.activeCategory = newMatch ? decodeURIComponent(newMatch[1]) : null;
      });

      window.addEventListener("categoryChanged", (e) => {
        this.activeCategory = e.detail.category;
      });
    },
    toggleMobileMenu() {
      this.open = !this.open;
    },
    closeMobileMenu() {
      this.open = false;
    },

    showFilters() {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = setTimeout(() => {
        this.filtersActive = true;
        this.headerBg.classList.add("with-filters");
      }, 200); // délai avant d'afficher
    },
    delayedHideFilters() {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = setTimeout(() => {
        this.filtersActive = false;
        this.headerBg.classList.remove("with-filters");
      }, 200); // délai avant de cacher
    },
    delayedHideMenu() {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = setTimeout(() => {
        this.menuVisible = false;
        this.filtersActive = false;
        this.headerBg.classList.remove("with-filters");
      }, 300);
    },
  }));
});

Alpine.start();

let accordionItems = [];
let accordionHeaders = [];
let currentOpen = null;

function closeItem(item) {
  const box = item.querySelector(".accordion-content");
  gsap.killTweensOf(box);
  gsap.to(box, {
    height: 0,
    duration: 0.45,
    ease: "power1.inOut",
    overwrite: "auto",
    onStart: () => {
      // s'assurer qu'on peut mesurer/voir l'anim
      box.style.overflow = "hidden";
    },
    onComplete: () => {
      item.classList.remove("open");
    },
  });
}

function openItem(item) {
  const box = item.querySelector(".accordion-content");
  gsap.killTweensOf(box);

  const target = box.scrollHeight;

  gsap.fromTo(
    box,
    { height: 0, overflow: "hidden" },
    {
      height: target,

      duration: 0.45,
      ease: "power1.inOut",
      overwrite: "auto",
      onStart: () => item.classList.add("open"),
      onComplete: () => {
        gsap.set(box, { height: "auto", overflow: "" });
      },
    }
  );
}

function toggleAccordion(header) {
  const item = header.closest(".accordion-item");
  const isOpen = item.classList.contains("open");

  if (currentOpen && currentOpen !== item) {
    closeItem(currentOpen);
  }
  if (isOpen) {
    closeItem(item);
    currentOpen = null;
  } else {
    openItem(item);
    currentOpen = item;
  }
}

function initAccordion() {
  if (!document.querySelector(".accordion-item")) return;
  if (
    window.innerWidth > 1440 &&
    document.body.classList.contains("product-template")
  ) {
    accordionItems = Array.from(document.querySelectorAll(".accordion-item"));
    accordionItems.forEach((item) => {
      const box = item.querySelector(".accordion-content");
      if (box) {
        box.style.cssText = "";
        gsap.set(box, { clearProps: "all" });
      }
    });
    return;
  }
  accordionItems = Array.from(document.querySelectorAll(".accordion-item"));
  accordionHeaders = accordionItems.map((it) =>
    it.querySelector(".accordion-header")
  );

  accordionItems.forEach((it) => {
    const box = it.querySelector(".accordion-content");
    if (!box) return;
    gsap.set(box, {
      height: 0,
      paddingTop: 0,
      paddingBottom: 0,
      overflow: "hidden",
    });
    it.classList.remove("open");
  });
  currentOpen = null;

  // 3) listeners clic + clavier
  accordionHeaders.forEach((header) => {
    header.addEventListener("click", () => toggleAccordion(header));
    header.setAttribute("role", "button");
    header.setAttribute("tabindex", "0");
    header.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggleAccordion(header);
      }
    });
  });

  // 4) re-mesurer sur resize si un item est ouvert
  window.addEventListener("resize", () => {
    if (!currentOpen) return;
    const box = currentOpen.querySelector(".accordion-content");
    if (!box) return;
    // si on est ouvert et en auto, recalculer la hauteur et la reposer
    if (getComputedStyle(box).height === "auto" || box.style.height === "") {
      const h = box.scrollHeight;
      gsap.set(box, { height: h }); // figer
      requestAnimationFrame(() => {
        gsap.set(box, { height: "auto" }); // remettre auto proprement
      });
    }
  });
}

function handleTitleFade(pageClass, titleClass) {
  const page = document.querySelector(pageClass);
  if (!page) return;

  const titleElement = page.querySelector(titleClass);
  if (!titleElement) return;

  gsap.set(titleElement, { autoAlpha: 1 });

  // Fade au scroll
  const fadeTrigger = ScrollTrigger.create({
    trigger: page,
    start: "top top",
    end: "top+=80",
    scrub: true,
    onUpdate: (self) => {
      const progress = self.progress;
      gsap.to(titleElement, {
        autoAlpha: 1 - progress,
        duration: 0.2,
        overwrite: true,
      });
    },
  });

  // Click direct sur le titre (desktop ou mobile)
  titleElement.addEventListener("click", () => {
    gsap.to(titleElement, { autoAlpha: 0, duration: 0.3, ease: "power2.out" });
    fadeTrigger.kill(); // évite qu'un scroll le ré-affiche
    titleElement.setAttribute("aria-hidden", "true");
  });

  // Mobile: tap/click n'importe où sur le body => disparaît + kill ST
  if (window.matchMedia("(pointer: coarse)").matches) {
    const dismiss = () => {
      gsap.killTweensOf(titleElement);
      gsap.to(titleElement, {
        autoAlpha: 0,
        duration: 0.25,
        ease: "power2.out",
      });
      fadeTrigger.kill(); // débranche le pin/scroll
      titleElement.setAttribute("aria-hidden", "true");
    };
    // premier tap/click seulement
    document.body.addEventListener("touchstart", dismiss, {
      once: true,
      passive: true,
    });
    document.body.addEventListener("click", dismiss, { once: true });
  }
}

function initScrollPagination() {
  const images = document.querySelectorAll(".scroll-images picture");
  const dots = document.querySelectorAll(".image-pagination .dot");

  if (!images.length || !dots.length) return;

  function updatePagination(index) {
    dots.forEach((dot, i) => {
      dot.classList.toggle("active", i === index);
    });
  }

  images.forEach((img, index) => {
    ScrollTrigger.create({
      trigger: img,
      start: "top center",
      end: "bottom center",
      onEnter: () => updatePagination(index),
      onEnterBack: () => updatePagination(index),
    });
  });

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      const index = parseInt(dot.dataset.index);
      if (!isNaN(index) && images[index]) {
        window.scrollTo({
          top: images[index].offsetTop,
          behavior: "smooth",
        });
      }
    });
  });
  ScrollTrigger.refresh();
}

if (document.querySelector(".js-autres-toggle")) {
  const autresTrigger = document.querySelector(".js-autres-toggle");
  const secondaryList = document.querySelector(".js-secondary-categories");

  let isHovered = false;
  let hoverTimeout;

  const showSecondary = () => {
    clearTimeout(hoverTimeout);
    isHovered = true;
    gsap.to(secondaryList, {
      autoAlpha: 1,
      duration: 0.3,
      display: "flex",
      ease: "power2.out",
    });
  };

  const hideSecondary = () => {
    isHovered = false;
    hoverTimeout = setTimeout(() => {
      if (!isHovered) {
        gsap.to(secondaryList, {
          autoAlpha: 0,
          duration: 0.3,
          display: "none",
          ease: "power2.in",
        });
      }
    }, 200);
  };

  autresTrigger.onmouseenter = showSecondary;
  autresTrigger.onmouseleave = hideSecondary;
  secondaryList.onmouseenter = () => {
    clearTimeout(hoverTimeout);
    isHovered = true;
  };
  secondaryList.onmouseleave = hideSecondary;
}

function initSwiperGallery() {
  if (document.querySelector(".swiper-gallery")) {
    new Swiper(".swiper-gallery", {
      slidesPerView: 1,
      spaceBetween: 0,
      direction: "vertical",
      mousewheel: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}
document.addEventListener("DOMContentLoaded", initPage);

function initPage() {

  const isCollab =
    document.querySelector(".collaborations-template") ||
    document.querySelector(".article-collab-template");

  if (isCollab) {
    const getOffsetPx = () =>
      window.matchMedia("(max-width: 767px)").matches ? 43 : 69;
    const startStr = () => `top ${getOffsetPx()}px`;
    const endStr = () => `bottom ${getOffsetPx()}px`;

    const initCollabScroll = () => {
      document.querySelectorAll(".article-item").forEach((article) => {
        const titleWrapper = article.querySelector(".article-title-wrapper");
        const image = article.querySelector(".article-image");
        const imageWrapper = article.querySelector(".article-image-wrapper");

        gsap
          .timeline({
            scrollTrigger: {
              trigger: titleWrapper,
              start: () => startStr(),
              scrub: true,
              pin: true,
              translate: 0,
              pinSpacing: false,
              invalidateOnRefresh: true,
            },
          })
          .to(titleWrapper.querySelector("h2"), {
            scale: 0,
            transformOrigin: "top center",
            ease: "none",
          });

        gsap
          .timeline({
            scrollTrigger: {
              trigger: imageWrapper,
              start: () => startStr(),
              end: () => endStr(),
              scrub: true,
              pin: true,
              pinSpacing: false,
              invalidateOnRefresh: true,
              anticipatePin: 1,
            },
          })
          .to(image, {
            scale: 0,
            x: 0,
            y: 0,
            transformOrigin: "top center",
            ease: "none",
          });
      });

      window.addEventListener("resize", () => {
        ScrollTrigger.refresh();
      });

      ScrollTrigger.refresh();
    };

    setTimeout(initCollabScroll, 150); // 50–150ms selon ton feeling
  }
  function initMenuscroll() {
    if (document.querySelector("#shop")) {
      ScrollTrigger.create({
        trigger: "#shop",
        start: "top 120px",
        end: "bottom bottom",
        onEnter: () =>
          document.querySelector("header").classList.add("in-shop"),
        onLeaveBack: () =>
          document.querySelector("header").classList.remove("in-shop"),
      });
    }
  }

  if (document.querySelector(".home-template")) {
    const titleWrapper = document.querySelector(".block-type-text");
    const centerMenu = document.querySelector(".center-menu");
    const blockIntro = document.querySelector(".block:first-of-type");
    const arrowBack = document.querySelector(".col-arrow-back");
    const logoMenu = document.querySelector(".logo-menu");
    const colMenuButton = document.querySelector(".col-menu-button");
    const cartbutton = document.querySelector(".col-cart");

    // Attendre que tout soit chargé (images, fonts, etc.)
    const initHomeAnimations = () => {
      // Forcer un refresh de ScrollTrigger après le chargement
      ScrollTrigger.refresh();

      gsap
        .timeline({
          scrollTrigger: {
            trigger: titleWrapper,
            start: "top 42px",
            end: "bottom 60px",
            translate: 0,
            scrub: true,
            pin: true,
            pinSpacing: false,
            invalidateOnRefresh: true, // Important !
          },
        })
        .to(titleWrapper.querySelector("p"), {
          scale: 0,
          transformOrigin: "top center",
          ease: "none",
        });

      gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
      const body = document.body;
      const indicator = document.querySelector(".scroll-indicator");

      function showIndicator() {
        if (!indicator) return;
        body.classList.add("with-scroll-indicator");
        gsap.set(indicator, { display: "flex", pointerEvents: "auto" });
        gsap.to(indicator, { opacity: 1, duration: 0.3, overwrite: "auto" });
      }

      function hideIndicator() {
        if (!indicator) return;
        gsap.to(indicator, {
          opacity: 0,
          duration: 0.3,
          overwrite: "auto",
          onComplete: () => {
            gsap.set(indicator, { display: "none", pointerEvents: "none" });
            body.classList.remove("with-scroll-indicator");
          },
        });
      }

      if (window.scrollY <= 0) {
        showIndicator();
      } else {
        hideIndicator();
      }

      setTimeout(() => {
        if (
          window.scrollY <= 0 &&
          body.classList.contains("with-scroll-indicator")
        ) {
          hideIndicator();
        }
      }, 3000);

      ScrollTrigger.create({
        trigger: document.documentElement,
        start: "top+=1 top", // dès qu’on a scrollé d’1px
        end: "bottom bottom",
        onEnter: () => hideIndicator(), // on a quitté le tout-haut
      });

      indicator?.addEventListener("click", () => {
        const y = window.scrollY + window.innerHeight;
        hideIndicator();

        gsap.to(window, {
          scrollTo: y, // nécessite ScrollToPlugin
          duration: 1,
          ease: "power2.out",
        });
      });

      if (isMobile == true) {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: blockIntro,
            start: "top top",
            end: "bottom top",
            scrub: 1,
            invalidateOnRefresh: true, // Ajouter ici aussi
          },
        });

        tl.to(logoMenu, { width: "38%", ease: "none" }, 0);
        tl.to(colMenuButton, { top: 0, left: "15px", ease: "none" }, 0);
        tl.to(cartbutton, { opacity: 1 });
        tl.to(arrowBack, { opacity: 1, ease: "none", duration: 0.3 });
      }
    };

    // Utiliser ImagesLoaded ou attendre un peu plus
    if (window.imagesLoaded) {
      imagesLoaded(blockIntro, initHomeAnimations);
    } else {
      // Fallback : attendre load + un petit délai
      window.addEventListener("load", () => {
        setTimeout(() => {
          initHomeAnimations();
        }, 100);
      });
    }

    // Refresh sur resize
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        ScrollTrigger.refresh();
      }, 250);
    });
  }

  const headerBg = document.querySelector(".header-bg");
  const menu = document.querySelector(".menu");
  let lastScrollTop = window.scrollY;
  let isScrollingUp = false;
  let isMenuHovered = false;

  const header = document.querySelector("header");
  const row = header?.querySelector(".page-title");
  const filters = header?.querySelector(".filters-links");

  function setCSSVar(name, px) {
    document.documentElement.style.setProperty(name, `${Math.round(px)}px`);
  }

  function updateHeights() {
    const headerH = row ? row.scrollHeight : 0;
    const filtersH = filters ? filters.scrollHeight + headerH : 0; // scrollHeight = contenu complet
    setCSSVar("--header-h", headerH);
    setCSSVar("--filters-h", filtersH);
    initAccordion();
  }

  function debounce(fn, delay = 150) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(null, args), delay);
    };
  }
  const updateHeightsDebounced = debounce(updateHeights, 150);

  window.addEventListener("DOMContentLoaded", updateHeights);
  window.addEventListener("load", updateHeights);
  window.addEventListener("resize", updateHeightsDebounced, { passive: true });
  window.addEventListener("orientationchange", updateHeightsDebounced);

  // optionnel : observer les changements de taille internes
  if (window.ResizeObserver && header) {
    const ro = new ResizeObserver(updateHeightsDebounced);
    ro.observe(header);
    if (filters) ro.observe(filters);
  }

  function showHeaderBg() {
    headerBg.classList.add("height1");
    isMenuHovered = true;
  }

  function hideHeaderBg() {
    isMenuHovered = false;
    setTimeout(() => {
      headerBg.classList.remove("height1");
      headerBg.classList.remove("with-filters");
    }, 200);
  }

  menu.addEventListener("mouseenter", showHeaderBg);
  menu.addEventListener("mouseleave", () => {
    hideHeaderBg();
  });

  window.addEventListener("scroll", () => {
    const currentScroll = window.scrollY;
    isScrollingUp = currentScroll < lastScrollTop;
    lastScrollTop = currentScroll;

    if (isScrollingUp) {
      showHeaderBg();
    } else if (!isMenuHovered) {
      hideHeaderBg();
    } else {
      hideHeaderBg();
    }
  });

  handleTitleFade(".product-page", ".product-title-svg");
  handleTitleFade(".article-page", ".big-article-title");
  if (isMobile !== true) {
    initScrollPagination();
  }

  initSwiperGallery();

  initAccordion();
  initMenuscroll();

  document.querySelectorAll(".logo-menu-w").forEach((el) => {
    el.addEventListener("click", (e) => {
      gsap.to(window, {
        duration: 1,
        scrollTo: "#content-home",
        ease: "power2.out",
      });
    });
  });

  if (isMobile) {
    if (document.querySelector(".gallery-mobile")) {
      const el = document.querySelector(".gallery-mobile .swiper");
      if (el) {
        const swiper = new Swiper(el, {
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", initPage);
